<template>
  <PageTable />
</template>
<script>
import PageTable from './table'
export default {
  name: 'ecom-sys-userThirdPartyApiSet',
  components: { PageTable },
}
</script>
